import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
  overflow: auto;
`;

export const Body = styled.div`
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;
  flex: 1;
  justify-content: flex-start;
  width: 100%;
  /* min-width: 1200px; */
  background-color: ${(props) => props.theme.colors.mainBackground};
`;
